import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-tabs-nav {
    margin: 0 0 0px 0 !important;
  }
`;
